import { CheckCircle } from "react-feather"

export default [
    {
        id: "HumanResource",
        header: "Хүний нөөц"
    },
    {
        id: "attendence",
        title: "Цагийн бүртгэл",
        icon: <CheckCircle size={20}/>,
        navLink: "humanresource/attendance"
    }
]